import React from 'react';
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import {Grid, Checkbox, withStyles} from "@material-ui/core";
import Button from "components/CustomButtons/Button.jsx";
import {appConstants} from "../../_constants";

const styles = theme => ({
    checked : {
        color: appConstants.PRIMARY_COLOR
    }
});

const Modal = (props) => {
    const {classes, handleClose, handleSubmit, checkAdult, isOpen, checkInfant, checkChild, adultKey, toggleCheck, childKey, infantKey, disabled} = props;
    return (
        <div>
            <Dialog
                open={isOpen}  //opens the modal
                onClose={handleClose} //closes the modal
            >
                <DialogTitle style={{ backgroundColor: appConstants.REGIONAL_LIGHT_COLOR }}>
                    <span style={{ color: "white", textTransform: "uppercase" }}> Add Record</span>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={24}>
                        <Grid item md={12} xs={12}>
                            <Checkbox
                                className={classes.checked}
                                checked={checkAdult}
                                Key={adultKey}
                                onClick={() =>toggleCheck("checkAdult")} //handler to mark or unmark the Adult check box. the argument "checkAdult" is passed into it.
                                                                          // "checkAdult" corresponds with checkAdult property in state.
                            />
                             Adult
                        </Grid>
                        <Grid item md={12} xs={12}>
                            <Checkbox
                                checked={checkChild}
                                Key={childKey}
                                onClick={() => toggleCheck("checkChild")}   //handler to mark or unmark the Child check box. the argument "checkChild" is passed into it.
                                                                               // "checkChild" corresponds with checkAdult property in state.
                            />
                            Child
                        </Grid>
                        <Grid item md={12} xs={12}>
                            <Checkbox
                                checked={checkInfant}
                                key={infantKey}
                                onClick={() => toggleCheck("checkInfant")}  //handler to mark or unmark the Infant check box. the argument "checkInfant" is passed into it.
                                                                             // "checkAdult" corresponds with checkInfant property in state.
                            />
                            Infant
                        </Grid>
                    </Grid>

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color={'danger'}>  {/* handleClose prop is used to close the modal*/}
                        Cancel
                    </Button>
                    <Button disabled={disabled} onClick={handleSubmit} color={"regional"} autoFocus> {/* handleSubmit prop is used to submit the modal*/}
                        Proceed
                    </Button>
                </DialogActions>
            </Dialog>

        </div>
    );
};

// export default Modal;
export default withStyles(styles)(Modal);


/*Written with love by Juliet */



// WEBPACK FOOTER //
// ./src/Regional-Views/BillablePscSettings/Modal.js